import React from "react";
import {
  drawCell,
  pickColor,
  pickTextColorBasedOnBgColor,
} from "../../../../utils";
import {
  DataPeriod,
  Measurement,
  MeasurementType,
} from "../../../../../store/onboarding/types";
import { Grade } from "../../../../../store/groups/types";

type Props = {
  index: number;
  element: any;
  measurement: Measurement;
  grade?: Grade,
  dataPeriod?: DataPeriod,
  mappedColumn?: string,
};

const PreviewDataCell = (props: Props) => {
  const { index, element, measurement, mappedColumn } = props;
  const elementMeasurementColumn = mappedColumn && (mappedColumn !== measurement.column_name)
    ? element[mappedColumn]
    : element[measurement.column_name!];
  const value =
    measurement.type !== MeasurementType.CATEGORY
      ? elementMeasurementColumn
      : measurement.possible_values!.find(
          (x) => x.display_name === elementMeasurementColumn
        );
  const bgColor = value
    ? measurement.type !== MeasurementType.CATEGORY
      ? pickColor(value, measurement, props.grade, props.dataPeriod)
      : pickColor(value.order, measurement)
    : undefined;
  const textColor = pickTextColorBasedOnBgColor(bgColor);
  return (
    <td
      key={index}
      style={{
        backgroundColor: bgColor,
        color: textColor,
        borderLeft: "3px #ffffff solid",
      }}
    >
      {drawCell(elementMeasurementColumn, measurement)}
    </td>
  );
};

export default PreviewDataCell;
